var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a, _b, _c;
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import DataTable from '@/components/data-table/DataTable';
import AreaFilter from '@/components/SummaryFilters/AreaFilter/AreaFilter';
import TopicFilter from '@/components/SummaryFilters/TopicFilter/TopicFilter.vue';
import LabelValue from '@/components/LabelValue.vue';
import { Subject } from '@/models/Subject';
import ErrorHandler from '@/support/ErrorHandler';
import { GraduationProfile } from '@/models/GraduationProfile';
let AddGraduationProfileDialog = class AddGraduationProfileDialog extends Vue {
    constructor() {
        // #region @VModel
        // #endregion
        super(...arguments);
        // #endregion
        // #region @Refs
        // #endregion
        // #region Class properties
        this.graduationProfile = null;
        this.selectedArea = '';
        this.area = null;
        this.selectedTopics = [];
        this.topics = [];
        this.currentStep = 1;
        this.isLoading = true;
        // #endregion
    }
    // #endregion
    // #region Lifecycle Hooks
    mounted() {
        this.initialize();
    }
    async initialize() {
        this.isLoading = true;
        await this.initializeGraduationProfile();
        this.$nextTick(() => {
            this.isLoading = false;
        });
    }
    // #endregion
    // #region Event handlers
    // #endregion
    // #region Class methods
    close() {
        this.$emit('input', false);
        this.clear();
    }
    clear() {
        this.graduationProfile = new GraduationProfile();
        this.currentStep = 1;
        this.selectedArea = '';
        this.area = null;
        this.selectedTopics = [];
        this.topics = [];
    }
    onSubmit() {
        if (!this.graduationProfile || !this.selectedArea || !this.selectedTopics) {
            return;
        }
        const payload = {
            name: this.graduationProfile.name,
            subject_id: this.selectedArea,
            subjects_ids: this.selectedTopics,
        };
        if (this.isEditing) {
            this.onUpdateGraduationProfile(payload);
        }
        else {
            this.onCreateGraduationProfile(payload);
        }
    }
    // #endregion
    // #region Async methods (api calls only)
    async onUpdateGraduationProfile(payload) {
        try {
            await this.existingGraduationProfile.update(payload);
            this.$emit('graduationProfileUpdated');
            this.clear();
        }
        catch (error) {
            ErrorHandler.network(error);
        }
    }
    async onCreateGraduationProfile(payload) {
        try {
            await new GraduationProfile().create(payload);
            this.$emit('graduationProfileCreated');
            this.clear();
        }
        catch (error) {
            ErrorHandler.network(error);
        }
    }
    async initializeGraduationProfile() {
        if (this.existingGraduationProfile) {
            console.log('this.existingGraduationProfile: ', this.existingGraduationProfile);
            this.graduationProfile = this.existingGraduationProfile;
            this.selectedArea = this.existingGraduationProfile.subject ? this.existingGraduationProfile.subject.id || '' : '';
            this.selectedTopics = this.existingGraduationProfile.subjects ? this.existingGraduationProfile.subjects.map((subject) => subject.id || '') : [];
        }
        else {
            this.graduationProfile = new GraduationProfile();
        }
    }
    async fetchAreaAndTopics() {
        this.isLoading = true;
        try {
            this.area = await new Subject().include(['children']).find(this.selectedArea);
            if (this.area && this.area.children) {
                this.selectedTopics.forEach((topic) => {
                    const foundTopic = this.area.children.find((child) => child.id === topic);
                    if (foundTopic) {
                        this.topics.push(foundTopic);
                    }
                });
            }
        }
        catch (error) {
            ErrorHandler.network(error);
        }
        finally {
            this.isLoading = false;
        }
    }
    // #endregion
    // #region Getters & Setters
    get selectedAreaName() {
        if (!this.area || !this.area.name) {
            return '-';
        }
        return this.area.name;
    }
    get selectedTopicsText() {
        if (!this.topics || this.topics.length === 0) {
            return '-';
        }
        return this.topics.map((topic) => topic.name).join(', ');
    }
    get disabled() {
        switch (this.currentStep) {
            case 1:
                return !this.graduationProfile || !this.graduationProfile.name;
            case 2:
                return !this.selectedArea;
            case 3:
                return !this.selectedTopics || this.selectedTopics.length === 0;
            case 4:
                return false;
            default:
                return true;
        }
    }
    get isEditing() {
        return !!this.existingGraduationProfile;
    }
    get submitButtonText() {
        return this.$tc('Save');
    }
    get title() {
        return this.isEditing ? this.$tc('Edit graduation profile') : this.$tc('Add graduation profile');
    }
    // #endregion
    // #region @Watchers
    async onCurrentStepChange(newStep) {
        if (newStep === 4) {
            await this.fetchAreaAndTopics();
        }
    }
    async onSelectedAreaChange() {
        if (this.existingGraduationProfile.subject && this.existingGraduationProfile.subject.id !== this.selectedArea) {
            this.selectedTopics = [];
        }
    }
    onExistingGraduationProfileChange() {
        this.isLoading = true;
        this.initializeGraduationProfile();
        this.isLoading = false;
    }
};
__decorate([
    Prop({ required: false }),
    __metadata("design:type", typeof (_a = typeof GraduationProfile !== "undefined" && GraduationProfile) === "function" ? _a : Object)
], AddGraduationProfileDialog.prototype, "existingGraduationProfile", void 0);
__decorate([
    Watch('currentStep'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", typeof (_b = typeof Promise !== "undefined" && Promise) === "function" ? _b : Object)
], AddGraduationProfileDialog.prototype, "onCurrentStepChange", null);
__decorate([
    Watch('selectedArea'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", typeof (_c = typeof Promise !== "undefined" && Promise) === "function" ? _c : Object)
], AddGraduationProfileDialog.prototype, "onSelectedAreaChange", null);
__decorate([
    Watch('existingGraduationProfile'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], AddGraduationProfileDialog.prototype, "onExistingGraduationProfileChange", null);
AddGraduationProfileDialog = __decorate([
    Component({
        components: {
            DataTable,
            AreaFilter,
            TopicFilter,
            LabelValue,
        },
    })
], AddGraduationProfileDialog);
export default AddGraduationProfileDialog;
// #region Enums
// #endregion
// #region Interfaces
// #endregion
// #region Constants
// #endregion
